import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IS_STORE_BUILD } from "../../config/storeBuild";

const LINK = "block text-center text-sm font-semibold text-primary transition hover:brightness-125";
const LEGAL = "hover:text-primary transition";

// روابط أسفل نموذج الدخول: نسخة المتاجر بلا أي دعوة للشراء (آبل 3.1.3(f)).
export const LoginLinks = () => {
  const { t } = useTranslation();
  return (
    <div className="space-y-2 pt-1">
      <Link to="/forgot-password" className={LINK} data-testid="forgot-link">
        {t("reset.forgotLink")}
      </Link>
      {IS_STORE_BUILD ? (
        <Link to="/signup" className={LINK} data-testid="signup-link">
          {t("signup.title")}
        </Link>
      ) : (
        <>
          <Link to="/pricing" className={LINK} data-testid="pricing-link">
            {t("pricingPage.link")}
          </Link>
          <Link to="/signup" className={LINK} data-testid="signup-link">
            {t("signup.title")}
          </Link>
        </>
      )}
      <p className="mt-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-xs font-semibold text-muted-foreground">
        <Link to="/terms" data-testid="login-terms-link" className={LEGAL}>{t("legal.terms")}</Link>
        <span aria-hidden="true">·</span>
        <Link to="/privacy" data-testid="login-privacy-link" className={LEGAL}>{t("legal.privacy")}</Link>
        <span aria-hidden="true">·</span>
        <Link to="/support" data-testid="login-support-link" className={LEGAL}>{t("support.title")}</Link>
      </p>
    </div>
  );
};
